import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function createRole(projectId, roleName, accessibilityCheckbox, color) {
	if (!projectId) {
		return {
			success: false,
		};
	}

	let roleId = roleName.replace(/\s/g, '').toLowerCase();

	if (!roleId) {
		return {
			success: false,
		};
	}

	// check roleId existance in DB
	let roleIdExist = false;
	await firebaseRef
		.ref('/kavtek_roles/' + projectId)
		.once('value', (snapshot) => {
			let roles = snapshot.val();
			if (roles) {
				let rolesArr = Object.keys(roles);
				if (rolesArr.includes(roleId)) {
					roleIdExist = true;
				}
			}
		});

	if (roleIdExist) {
		return {
			success: false,
			roleIdExist: true,
		};
	} else {
		let role = firebaseRef.ref('/kavtek_roles/' + projectId + '/' + roleId);
		let accessibilities = {};
		for (let key in accessibilityCheckbox) {
			if (accessibilityCheckbox[key]) {
				let [module, feature, action] = key.split('-');

				if (!accessibilities[module]) {
					accessibilities[module] = {};
				}
				if (!accessibilities[module][feature]) {
					accessibilities[module][feature] = [];
				}
				accessibilities[module][feature].push(Number(action));
			}
		}

		role.set({
			roleId: roleId,
			roleName: roleName,
			accessibilities: accessibilities,
			roleType: 'custom',
			projectCode: projectId,
			color: color
		});
		return {
			success: true,
			roleId: roleId
		};
	}
}
